/**
 * Account close modes for Me → Delete account.
 * Match history is never cascade-deleted (ADR-018 / ADR-019).
 */

export const ACCOUNT_CLOSE_MODE_RETAIN = "retain";
export const ACCOUNT_CLOSE_MODE_ERASE = "erase";

export const ACCOUNT_STATUS_ACTIVE = "active";
export const ACCOUNT_STATUS_CLOSED_RETAIN = "closed_retain";

/** Live player label after erase — historical matchParticipants keep their snapshots. */
export const CLOSED_PLAYER_DISPLAY_NAME = "Former player";
export const CLOSED_PLAYER_NORMALIZED_NAME = "former player";

/** Non-discoverable search token (name search will not surface closed players). */
export const CLOSED_PLAYER_SEARCH_KEYWORDS = ["__closed"];

/**
 * @param {string} mode
 * @returns {mode is typeof ACCOUNT_CLOSE_MODE_RETAIN | typeof ACCOUNT_CLOSE_MODE_ERASE}
 */
export function isAccountCloseMode(mode) {
  return mode === ACCOUNT_CLOSE_MODE_RETAIN || mode === ACCOUNT_CLOSE_MODE_ERASE;
}
